@if (visible) {
    <div class="entity-carousel" [ngClass]="{ 'area-placeholder': isBusy && items.length === 0 }">

        <div class="entity-carousel__header">
            <div class="entity-carousel__title-row">
                <div class="headline-small">{{ title }}</div>
                @if (actionText) {
                    <dx-button
                        type="default"
                        [icon]="actionIcon ?? ''"
                        [text]="actionText"
                        (onClick)="actionClick.emit()">
                    </dx-button>
                }
            </div>

            <div class="entity-carousel__view-toggle">
                <dx-button
                    type="default"
                    [class]="viewTypeCards ? 'active-button' : ''"
                    (onClick)="viewAsCards()"
                    stylingMode="outlined"
                    [text]="'Installations.SlideView' | i18next">
                </dx-button>
                <dx-button
                    type="default"
                    [class]="!viewTypeCards ? 'active-button' : ''"
                    (onClick)="viewAsList()"
                    stylingMode="outlined"
                    [text]="'Installations.ListView' | i18next">
                </dx-button>
            </div>
        </div>

        <div class="entity-carousel__body">
            @if (viewTypeCards) {
                <dx-button
                    *ngIf="showBackButton"
                    class="entity-carousel__nav entity-carousel__nav--back"
                    type="default"
                    icon="chevronleft"
                    (click)="scrollLeft()">
                </dx-button>

                <dx-button
                    *ngIf="showForwardButton"
                    class="entity-carousel__nav entity-carousel__nav--forward"
                    type="default"
                    icon="chevronright"
                    (click)="scrollRight()">
                </dx-button>

                <dx-scroll-view
                    #scrollView
                    direction="horizontal"
                    (onScroll)="updateScrollButtons()"
                    (onUpdated)="updateScrollButtons()">
                    <div class="entity-carousel__cards">
                        <ng-container *ngFor="let item of items">
                            <ng-container *ngTemplateOutlet="cardTemplate; context: { $implicit: item }">
                            </ng-container>
                        </ng-container>

                        @if (showPlaceholders) {
                            @for (_ of [].constructor(placeholderCount); track $index) {
                                <div class="entity-carousel__placeholder"></div>
                            }
                        }
                    </div>
                </dx-scroll-view>
            } @else {
                <ng-container *ngTemplateOutlet="listTemplate"></ng-container>
            }
        </div>

    </div>
}
